import React from 'react';
import { Link } from 'react-router-dom';
import '../../App.scss'

// Creating the main view of the posts in home

export default function PostCard(props) {
    const {
            image,
            name="fulano",
            readable_publish_date="17 de sep",
            title="post de prueba",
            positive_reactions_count=9,
            reading_time_minutes=6,
            tags,
            tag_list=['tagdemo1','tagdemo2'],
            _id,
            display
        } = props
    return(
            <div className="card br-post post-card featured-post-card mb-2" >    
                        <img src={image} className={`card-img-top ${display}`} alt="image not found" style={{height:"200px"}} />
                        <div className="card-body">
                            <div className="d-flex c-header">
                            <img alt="" className="br-100" />
                            <div className="d-flex c-name">
                                <h6 className="nickname mb-0">{name}</h6>
                                <p>{readable_publish_date}</p>
                            </div>
                        </div>
                        <div className="card-content pl-5 pt-2">
                            <Link to={`/postDetail/${ _id }`}  className="post-list" >
                                <h4 className="card-title">{title}</h4>
                            </Link>
                        <div className="d-flex h-order">
                            <nav className="card-post-tags">
                                {tags.split(" ").map((tag,index)=>{
                                    return <span className ="text-muted" key={index}>{"#"+tag+" "}</span>})
                                }
                            </nav>
                        </div>
                        <div className="d-flex read">
                    
                    <div className="d-flex">
                    <div>
                    <a href="post_detail.html?key=${postId}" className="post-list">
                    <svg className="crayons-icon" width="24" height="24" 
                        xmlns="http://www.w3.org/2000/svg"><path d="M18.884 12.595l.01.011L12 19.5l-6.894-6.894.01-.01A4.875 4.875 0 0112 5.73a4.875 4.875 0 016.884 6.865zM6.431 7.037a3.375 3.375 0 000 4.773L12 17.38l5.569-5.569a3.375 3.375 0 10-4.773-4.773L9.613 10.22l-1.06-1.062 2.371-2.372a3.375 3.375 0 00-4.492.25v.001z"></path></svg>
                        <button className="comment"><span>{positive_reactions_count}</span> reactions</button>
                    </a>
                        </div>
                    <div>
                    
                    <svg xmlns="http://www.w3.org/2000/svg" width="24"
                        height="24" role="img"
                        aria-labelledby="aavwx5vmqdgx8wvzfg593jo469ge3dnz"
                        className="crayons-icon mb-1">
                        <path
                            d="M10.5 5h3a6 6 0 110 12v2.625c-3.75-1.5-9-3.75-9-8.625a6 6 0 016-6zM12 15.5h1.5a4.501 4.501 0 001.722-8.657A4.5 4.5 0 0013.5 6.5h-3A4.5 4.5 0 006 11c0 2.707 1.846 4.475 6 6.36V15.5z">
                        </path>
                    </svg>
                    Add comment
                    </div>
                    </div>
                    <div className="d-flex">
                    <p className="card-text mb-0"><small classNameName="text-muted">{reading_time_minutes+" min read"}</small></p>
                    <button className="save">Save</button>
                </div>
            </div>
        </div>
        </div>
    </div>
    )
}